import { Schema } from '@blade/std-lib'

export class InstagramResizePostMessage extends Schema.Class<InstagramResizePostMessage>(
  'InstagramResizePostMessage',
)({
  type: Schema.Literal('MEASURE'),
  details: Schema.Struct({
    height: Schema.Number,
  }),
}) {
  static decode = Schema.decodeUnknownOption(
    Schema.fromJsonString(InstagramResizePostMessage),
  )
}
